// extracted by mini-css-extract-plugin
module.exports = {"main":"styles_main__1TioL","innerCircle":"styles_innerCircle__3eBx8","off":"styles_off__3Fhmc"};